import LoadingOutlined from '@ant-design/icons/lib/icons/LoadingOutlined';
import Spin from 'antd/es/spin';

const antIcon = ({ fontSize }) => <LoadingOutlined style={{ fontSize: fontSize }} spin />;
const LoadingIndicator = ({ indicatorFontSize = 24 }): JSX.Element => (
  <Spin indicator={antIcon({ fontSize: indicatorFontSize })} />
);
export default LoadingIndicator;
